import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const addTextblock = async (textblock) => {
    return axios.post(`${BACKEND_URL}/textblocks`, textblock);
};

export const getTextblocks = async() => {
    return axios.get(`${BACKEND_URL}/textblocks`);
};

export const getTextblocksOfCoach = async (email) => {
    return axios.get(`${BACKEND_URL}/textblocks/${email}`);
};

export const updateTextblock = async (id, textblock) => {
    return axios.put(`${BACKEND_URL}/textblocks/${id}`, textblock);
};

export const deleteTextblock = async (id) => {
    return axios.delete(`${BACKEND_URL}/textblocks/${id}`);
};